import React, { useState, useEffect } from 'react';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import RepaymentSection from './Components/RepaymentSection/RepaymentSection';
import PaymentFailedPopup from 'components/PaymentFailedPopup/PaymentFailedPopup';
import styles from './UpdatePaymentPlanConfirmPageData.module.scss';
import { useHistory } from 'react-router-dom';
import PageLink from 'components/PageLink/PageLink';
import Button from 'components/Button/Button';
import http from 'app/http';
import { useLocation } from 'react-router-dom';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { getParamValue } from 'common/helpers/urlParams';
import classNames from 'classnames/bind';
interface Props {
    PageData?: any;
    Model?: any;
    LayoutModel?: any;
}
const UpdatePaymentPlanConfirmPageDate = (props: Props) => {
    const { Model, PageData, LayoutModel } = props;
    const [mainCotent, setmainContent] = useState(true);
    const [progressContent, setprogressContent] = useState(false);
    const [eventTracked, setEventTracked] = useState<boolean>(false);
    const location = useLocation();
    const history = useHistory();
    const [showPaymentFailedPopup, setShowPaymentFailedPopup] = useState(
        Model.IsPaymentError
    );
    const [showPaymentSecondAttempt, setShowPaymentSecondAttempt] = useState(
        Model.IsPaymentSecondAttempt
    );
    const getPathnameFromUrl = (url: string) => {
        const link = new URL(url);

        return link.pathname + link.search;
    };
    const currentURL = window.location.href;
    var payerReviewStatus = getParamValue(currentURL, 'payerReviewStatus') || '';
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location, progressContent]);
    const submitClick = async (e: any) => {
        setmainContent(false);
        setprogressContent(true);

        try {
            const response = await http.get(
                Model.ConfirmUrl,
                // Convert object into string

                {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                },
            );
            if (response && response.data) {
                // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
                //const nextPagePath = getPathnameFromUrl(response.data.data);
                const nextPagePath = getPathnameFromUrl(response.data.data);
                history.push(nextPagePath, {
                    noRefresh: false,
                });
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        if (LayoutModel != undefined) {
            var userid =
                LayoutModel?.Profiles.length > 0
                    ? LayoutModel?.Profiles[0].DebtReference
                    : '';
            var isLoggedIn = LayoutModel?.HasProfile;
            var lang = PageData?.Language;
            var env = LayoutModel?.Environment;
            var reg = LayoutModel?.CountryCode;
            getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
            getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
        }
    }, [LayoutModel]);
    useEffect(() => {

        if (eventTracked == false) {
            var tagManagerArgs: any;
            if (payerReviewStatus != '') {
                tagManagerArgs = {
                    dataLayer: {
                        event: 'checkout_step',
                        checkout_name: 'Payment Plan Review',
                        checkout_step_number: '1',
                        is_secured_user: LayoutModel?.IsLoggedInUserSecured,
                        ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
                    },
                };
                TagManager.dataLayer(tagManagerArgs);

            }

            tagManagerArgs = {
                dataLayer: {
                    event: 'checkout_step',
                    checkout_name: 'Payment Plan Update',
                    checkout_step_number: '3',
                    is_secured_user: LayoutModel?.IsLoggedInUserSecured,
                    ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
                }
            }
            TagManager.dataLayer(tagManagerArgs);

            if (Model.IsPaymentError) {
                tagManagerArgs = {
                    dataLayer: {
                        event: 'form_error',
                        checkout_name: 'Payment Plan Update',
                        error_message: 'Failed payment',
                        failure_number: (Model.IsPaymentSecondAttempt ? '2' : '1')
                    }
                };
                TagManager.dataLayer(tagManagerArgs);
            }
            setEventTracked(true);
        }
    }, [eventTracked]);
    return (
        <div className={styles.wrapper}>
            <section className="Section Section--portal u-paddingTz">
                <div className={styles.section}>
                    {mainCotent && (
                        <div id="main-content">
                            {!Model.IsPaymentError && (
                                <>
                                    <ChangePlanHeader Headingtext={PageData?.Heading} />

                                    <RepaymentList
                                        Heading={PageData?.PlanDetailsHeadingLabel}
                                        Monthlylabel={
                                            PageData?.PlanDetailsNumberofInstallmentsLabel
                                        }
                                        Mothlyamount={
                                            Model?.PlanDetails?.PlanDetailsNumberofInstallments
                                        }
                                        Finallabel={PageData?.PlanDetailsFinalPaymentAmountLabel}
                                        FinalAmount={
                                            Model?.PlanDetails?.PlanDetailsFinalPaymentAmount
                                        }
                                        Totaltext={PageData?.PlanDetailsTotalPlanLabel}
                                        Totalamount={Model?.PlanDetails?.PlanDetailsCurrentBalance}
                                        BalanceLabel={PageData?.PlanDetailsCurrentBalanceLabel}
                                        BalanceAmount={Model?.PlanDetails.PlanDetailsCurrentBalance}
                                        PaymentMethodLabel={PageData?.PlanDetailsPaymentMethodLabel}
                                        PaymentMethod={Model?.PlanDetails.PlanDetailsPaymentMethod}
                                        CustomerNumberLabel={
                                            PageData?.PlanDetailsCustomerNumberLabel
                                        }
                                        CustomerNumber={
                                            Model?.PlanDetails?.PlanDetailsCustomerNumber
                                        }
                                        PlanDueDate={
                                            Model?.PlanDetails.PlanDetailsFirstPaymentDueDate
                                        }
                                        PlanDueDateInfoText={
                                            Model?.IsManualPaymentMethod
                                                ? PageData?.FirstPaymentDueDateManualDetails
                                                : PageData?.FirstPaymentDueDateDetails
                                        }
                                        UpdatePlanConfirm={true}
                                    />
                                </>
                            )}

                            {!Model.IsPaymentError && (
                                <div className="Grid">
                                    <div className="Grid-cell">
                                        <div className="ButtonBar ButtonBar--spaceBetween ButtonBar--row-reverse ButtonBar-sm--spaceBetween">
                                            <Button
                                                text={PageData.ConfirmBtnLabel}
                                                className="Button"
                                                onClick={submitClick}
                                            />

                                            <PageLink
                                                className="Button Button--gray"
                                                text={PageData.BackBtnLabel}
                                                url={Model.BackUrl}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {progressContent && (
                    <div id="ProgressView">
                        <main className="CreateRepaymentPlan">
                            <section className="CreateRepaymentPlan__processPayment">
                                <h1 className="CreateRepaymentPlan__heading CreateRepaymentPlan__heading--centerAlign">
                                    {PageData.SavingChangesHeading}
                                </h1>
                                <div className="paymentProcess">
                                    <img
                                        className="paymentProcess__loader"
                                        src={`${process.env.PUBLIC_URL}/images/icons/loader/loader.gif`}
                                    />
                                    <p className="paymentProcess__statement">
                                        {PageData.PleaseWaitText}
                                    </p>

                                    <p className="paymentProcess__notice">
                                        {PageData.DoNotClosePageText}
                                    </p>
                                </div>
                            </section>
                        </main>
                    </div>
                )}
            </section>
            {Model.IsPaymentError && (
                <div className="Grid">
                    <div className="Grid-cell u-textCenter u-marginTxsm">
                        <PageLink
                            className="Button Button--ghost Button--mobFull"
                            text={PageData.CloseButtonLabel}
                            url={Model.ClosePageUrl}
                        />
                    </div>
                </div>
            )}
            <div
                className={classNames(
                    'modal-overlay',
                    showPaymentFailedPopup ? 'is-active' : '',
                )}
            >
                <PaymentFailedPopup CallUsNowButtonText={PageData?.CallUsNowButtonText}
                    PaymentErrorHeader={PageData?.PaymentErrorHeader}
                    PaymentErrorInfo={PageData?.PaymentErrorInfo}
                    PaymentErrorSecondAttemptInfo={PageData?.PaymentErrorInfoSecondAttemptContent}
                    TryAgainButtonText={PageData?.TryAgainButtonText}
                    SendMessageButtonText={PageData?.SendMessageButtonText}
                    handleClick={() => { setShowPaymentFailedPopup(false); }}
                    ShowSecondAttempt={showPaymentSecondAttempt}
                    PlanUpdateFlow={true}
                    RequestCallBackButtonText = {PageData?.RequestCallBackButtonText}
                    {...props} />
            </div>
            
        </div>
    );
};

export default UpdatePaymentPlanConfirmPageDate;
